import React from 'react';
import { useAtomValue } from 'jotai';
import isNumber from 'lodash/isNumber';
import type { GetULabelConfigFunction } from '../../../../../common/providers/feature-flag-provider';
import type { ContentRect } from '../../../../../common/types/content-rect';
import { isVideoPlayerAtom, metadataAtom } from '../../../atoms/file-atoms';
import { hoveredFrameAtom } from '../../../atoms/video-playback-atoms';
import { HoveredFrame } from './hovered-frame';
type PropsT = {
  container: HTMLDivElement | null;
  containerDimensions: ContentRect | null;
  getULabelConfig: GetULabelConfigFunction | null;
};
export const HoveredFrameContainer = ({
  container,
  containerDimensions,
  getULabelConfig
}: PropsT) => {
  const isVideoPlayer = useAtomValue(isVideoPlayerAtom);
  const metaData = useAtomValue(metadataAtom);
  const hoveredFrame = useAtomValue(hoveredFrameAtom);
  if (!container || !containerDimensions) {
    return null;
  }
  if (!isNumber(hoveredFrame)) {
    return null;
  }
  return <HoveredFrame isVideoPlayer={isVideoPlayer} getULabelConfig={getULabelConfig} imageMetaData={metaData} container={container} containerDimensions={containerDimensions} hoveredFrame={hoveredFrame} />;
};